export default __webpack_public_path__ + "static/media/jpg.aa8c76ea.svg";